export const times = [
    {
        time: '0600',
        capacity: 30,
        days: [1, 2, 3, 4, 5]
    },
    {
        time: '0700',
        capacity: 30,
        days: [1, 2, 3, 4, 5]
    }
]

export const staticProfile = {
  userId: 'abc',
  displayName: 'user',
  pictureUrl: '/mstile-150x150.png'
}
export const DensityWeight = [1, 0.8, 0.6]

export const densityColors = [
    '#ccc',
    '#F7BD40',
    '#F77474',
    '#CF3E90',
    '#703791'
]

export const RANKS = [
    'นนอ.',        'นจอ.', 'นพอ.',
    'พลฯ',         'พลอาสาสมัคร', 'จ.ต.กองฯ',
    'กห.ป.(ญ)',    'กห.ป.(ช)',   'จ.ต.หญิง',
    'จ.ต.',        'จ.ท.หญิง',    'จ.ท.',
    'จ.อ.หญิง',     'จ.อ.',       'พ.อ.ต.หญิง',
    'พ.อ.ต.',      'พ.อ.ท.หญิง',  'พ.อ.ท.',
    'พ.อ.อ.หญิง',   'พ.อ.อ.',     'พ.อ.อ.(พ) หญิง',
    'พ.อ.อ.(พ)',   'กห.ส.(ญ)',   'กห.ส.(ช)',
    'ร.ต.หญิง',     'ร.ต.',       'ร.ท.หญิง',
    'ร.ท.',        'ร.อ.หญิง',    'ร.อ.',
    'น.ต.หญิง',     'น.ต.',       'น.ท.หญิง',
    'น.ท.',        'น.อ.หญิง',    'น.อ.',
    'น.อ.(พ) หญิง', 'น.อ.(พ)',    'พล.อ.ต.หญิง',
    'พล.อ.ต.',     'พล.อ.ท.หญิง', 'พล.อ.ท.',
    'พล.อ.อ.หญิง',  'พล.อ.อ.',    'พล.อ.อ.*หญิง',
    'พล.อ.อ.*'
  ]

export const RTAFUNITS = [
  {
    name: 'สำนักงานผู้บัญชาการทหารอากาศ',
    abbr: 'สน.ผบ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: '​ศูนย์อำนวยการเครื่องบินพระราชพาหนะ​​',
    abbr: 'ศบพ.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: 'ศูนย์อำนวยการเฮลิคอปเตอร์พระราชพาหนะ',
    abbr: 'ศฮพ.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: 'ศูนย์การสงครามทางอากาศ',
    abbr: 'ศกอ.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: '​สำนักงานพัฒนาระบบราชการกองทัพอากาศ',
    abbr: 'สพร.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: 'สำนักงานยุทธศาสตร์และหลักนิยมกองทัพอากาศ(เพื่อพลาง)​',
    abbr: 'สยล.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: '​สำนักงานประสานภารกิจด้านความมั่นคงกับกองอำนวยการรักษาความมั่นคงภายในราชอาณาจักรกองทัพอากาศ​',
    abbr: 'สง.ปรมน.ทอ.',
    unittype: 'กองบัญชาการ'
  },
  {
    name: 'สำนักงานเลขานุการกองทัพอากาศ',
    abbr: 'สลก.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมกำลังพลทหารอากาศ',
    abbr: 'กพ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมยุทธการทหารอากาศ',
    abbr: 'ยก.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมกิจการพลเรือนทหารอากาศ',
    abbr: 'กร.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมข่าวทหารอากาศ',
    abbr: 'ขว.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมส่งกำลังบำรุงทหารอากาศ',
    abbr: 'กบ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมเทคโนโลยีสารสนเทศและการสื่อสารทหารอากาศ',
    abbr: 'ทสส.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมการเงินทหารอากาศ',
    abbr: 'กง.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'สำนักงานการบินกองทัพอากาศ',
    abbr: 'สบน.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'ศูนย์ไซเบอร์กองทัพอากาศ',
    abbr: 'ศซบ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'สำนักงานปลัดบัญชีทหารอากาศ',
    abbr: 'สปช.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมจเรทหารอากาศ',
    abbr: 'จร.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'สำนักงานพระธรรมนูญทหารอากาศ',
    abbr: 'สธน.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'สำนักงานนิรภัยทหารอากาศ',
    abbr: 'สนภ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'สำนักงานตรวจสอบภายในทหารอากาศ',
    abbr: 'สตน.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กรมสารบรรณทหารอากาศ',
    abbr: 'สบ.ทอ.',
    unittype: 'ส่วนบัญชาการ'
  },
  {
    name: 'กองบัญชาการควบคุมการปฏิบัติทางอากาศ',
    abbr: 'คปอ.',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'ศูนย์ปฏิบัติการทางอวกาศกองทัพอากาศ',
    abbr: 'ศปอว.ทอ.',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'หน่วยบัญชาการอากาศโยธิน',
    abbr: 'อย.',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'โรงเรียนการบิน',
    abbr: 'รร.การบิน',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๑',
    abbr: 'บน.๑',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๒',
    abbr: 'บน.๒',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๓',
    abbr: 'บน.๓',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๔',
    abbr: 'บน.๔',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๕',
    abbr: 'บน.๕',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๖',
    abbr: 'บน.๖',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๗',
    abbr: 'บน.๗',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๒๑',
    abbr: 'บน.๒๑',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๒๓',
    abbr: 'บน.๒๓',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๔๑',
    abbr: 'บน.๔๑',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๔๖',
    abbr: 'บน.๔๖',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กองบิน ๕๖',
    abbr: 'บน.๕๖',
    unittype: 'ส่วนกำลังรบ'
  },
  {
    name: 'กรมช่างอากาศ',
    abbr: 'ชอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมสื่อสารอิเล็กทรอนิกส์ทหารอากาศ',
    abbr: 'สอ.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมสรรพาวุธทหารอากาศ',
    abbr: 'สพ.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมพลาธิการทหารอากาศ',
    abbr: 'พอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมช่างโยธาทหารอากาศ',
    abbr: 'ชย.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมขนส่งทหารอากาศ',
    abbr: 'ขส.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'ศูนย์ซอฟต์แวร์กองทัพอากาศ',
    abbr: 'ศซว.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมพลาธิการทหารอากาศ',
    abbr: 'พธ.ทอ.',
    unittype: 'ส่วนส่งกำลังบำรุง'
  },
  {
    name: 'กรมยุทธศึกษาทหารอากาศ',
    abbr: 'ยศ.ทอ.',
    unittype: 'ส่วนการศึกษา'
  },
  {
    name: 'โรงเรียนนายเรืออากาศนวมินทกษัตริยาธิราช',
    abbr: 'รร.นนก.',
    unittype: 'ส่วนการศึกษา'
  },
  {
    name: 'กรมสวัสดิการทหารอากาศ',
    abbr: 'สก.ทอ.',
    unittype: 'ส่วนกิจการพิเศษ'
  },
  {
    name: 'ศูนย์วิจัยพัฒนาวิทยาศาสตร์เทคโนโลยีการบินและอวกาศกองทัพอากาศ',
    abbr: 'ศวอ.ทอ.',
    unittype: 'ส่วนกิจการพิเศษ'
  },
  {
    name: 'สถาบันเวชศาสตร์การบินกองทัพอากาศ',
    abbr: 'สวบ.ทอ.',
    unittype: 'ส่วนกิจการพิเศษ'
  },
  {
    name: 'สำนักงานผู้บังคับทหารอากาศดอนเมือง',
    abbr: 'สน.ผบ.ดม.',
    unittype: 'ส่วนกิจการพิเศษ'
  }
]

export const personnelTypes = ["ลูกค้าทั่วไป", "เทรนเนอร์"];

  const thaiProvinces = require('./data/thai_provinces.json');

export const personprops = {
  rank: {
    name: "rank",
    label: "คำนำหน้า",
    required: true,
    type: "select",
    options: ["นาย", "นาง", "นางสาว"],
    grid: 4,
  },
  name: {
    name: "name",
    label: "ชื่อ",
    required: true,
    grid: 4,
  },
  surname: {
    name: "surname",
    label: "นามสกุล",
    required: true,
    grid: 4,
  },
  type: {
    name: "type",
    label: "ประเภทผู้ใช้",
    preferred: true,
    type: "select",
    options: personnelTypes,
    grid: 8,
  },
  province: {
    name: 'province',    
    label: 'ภูมิลำเนา',
    required: true,
    type: 'select',
    options: Object.values(thaiProvinces)
      .map((p) => p.name_th)
      .toSorted(),
    grid: 6
  },
  position: {
    name: "position",
    label: "ตำแหน่ง",
    preferred: true,
  },
  tel: {
    name: "tel",
    label: "โทร.",
    required: true,
    // type: 'multiple',
    // separator: '|',
    grid: 6,
  },
  email: {
    name: "email",
    label: "อีเมล์",
    preferred: true,
    // type: 'multiple',
    // separator: '|',
    grid: 6,
  },
};

export const runwayconfig = {
  openingTime: {

  }
}

export const tocs = [
  {
    name: 'policy',
    label: 'นโยบายความเป็นส่วนตัว LINE',
    info: 'ท่านได้ยอมรับการใช้งานไลน์แล้ว กดอ่านเพิ่มเติม',
    checked: true,
    uri: 'https://line.me/th/terms/policy/'
  },
  {
    name: 'lineterm',
    label: 'ข้อกำหนดและเงื่อนไขการใช้ LINE',
    info: 'ท่านได้ยอมรับการใช้งานไลน์แล้ว กดอ่านเพิ่มเติม',
    checked: true,
    uri: 'https://terms.line.me/line_terms?lang=th'
  },  {
    name: 'linedatausage',
    label: 'ระเบียบการใช้งาน',
    info: 'ระเบียบการใช้งานห้องออกกำลังกาย The Runway',
    uri: 'https://flexitarmstrong.web.app/gymrules'
  }
]

export const CHECKINTYPE = {
    queued: {
        name: 'queued',
        label: '✅'
    },
    beaconwalkin: {
        name: 'beaconwalkin',
        label: '🟦🕺🏼'

    },
    qrwalkin: {
        name: 'qrwalkin',
        label: '🤳'

    },
    walkin: {
        name : 'walkin',
        label: '☑️🕺🏼'
    }
}

export const ROLES = {

  'none': {
    name: 'ไม่มี'
  },
  'user': {
    name: 'ผู้ใช้บริการ'
  },
  'staff': {
    name: 'Staff',
    rights: ['viewcheckin']
  },
  'trainer': {
    name: 'Trainer',
    rights: []
  },
  'trainerojt': {
    name: 'Trainer OJT',
    rights: []
  },
  'commander': {
    name: 'ผู้บังคับบัญชาระดับสูง',
    rights: ['viewcheckin']
  },
  'vip': {
    name: 'แขกพิเศษ'
  },
  'admin': {
    name: 'ผู้ดูแลระบบ',
    rights: ['viewcheckin']
  },
  'superadmin': {
    name: 'ผู้จัดการ',
    rights: ['viewcheckin']
  }
}

const TEMP_COLORS = {
  30: "#872341",
  27: "#BE3144",
  24: "#E36414",
  20: "#40A2D8",
  18: "#BBE2EC"

}

export const inbodyUrls = {
  ios: 'https://apps.apple.com/th/app/inbody/id884923678',
  android: 'https://play.google.com/store/apps/details?id=com.inbody2014.inbody&hl=th_TH%20',
  web: 'https://inbodyusa.com/inbody-app/',
}

export const getTempColors = (temp) => {
  const counts = Object.keys(TEMP_COLORS);
  const output = counts.reduce((prev, curr) => Math.abs(curr - temp) < Math.abs(prev - temp) ? curr : prev);
  console.log(temp, output, TEMP_COLORS[output]);
  return TEMP_COLORS[output]

}